import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M15.227 12.141a.2.2 0 0 0 0-.283L8.934 5.567a.8.8 0 0 1 1.132-1.132l6.292 6.293a1.8 1.8 0 0 1 0 2.546l-6.292 6.293a.8.8 0 1 1-1.132-1.132z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }